module.exports = __webpack_public_path__ + "assets/img/seta.17649576.svg";